import React, { useState } from 'react';
import NavBar from '../componance/NavBar';
import Footer from '../componance/Footer';
import { Link, useNavigate, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from './AuthContext';


const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { user, login } = useAuth();

  // ✅ Redirect ถ้า login แล้ว
  if (user) {
    return <Navigate to="/" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('https://summerhousagentlive.onrender.com/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password: password.trim() }),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('token', data.token);
        const decoded = jwtDecode(data.token);

        login({
          id: decoded.userId,
          username: decoded.username,
          role: decoded.role,
        });

        alert('Login successful');
        decoded.role.toLowerCase() === 'admin'
          ? navigate('/dashboardadmin')
          : navigate('/');
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Error connecting to server');
    }
  };

  return (
    <div style={styles.container}>
      <NavBar />
      <div style={styles.formContainer}>
        <h2 style={styles.heading}>Login</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="Username or Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />
          <button type="submit" style={styles.button}>Login</button>
        </form>
        {error && <p style={styles.error}>{error}</p>}
        <p>
          Don't have an account? <Link to="/signupform" style={styles.link}>Sign Up</Link>
        </p>
        <p>
          ลืมรหัสผ่าน? <Link to="/forgot-password" style={styles.link}>กดที่นี่</Link>
        </p>
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', padding: '20px', paddingTop: '0px',
    minHeight: '100vh', paddingBottom: '0',
  },
  heading: {
    fontSize: '28px', fontWeight: 'bold', marginBottom: '20px', color: '#2980b9'
  },
  form: {
    width: '100%', display: 'flex', flexDirection: 'column', gap: '15px'
  },
  input: {
    padding: '12px', fontSize: '16px', borderRadius: '8px',
    border: '1px solid #ddd', backgroundColor: '#f9f9f9'
  },
  button: {
    padding: '12px', backgroundColor: '#2980b9', color: '#fff',
    border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer'
  },
  error: {
    color: '#e74c3c', fontSize: '14px', marginTop: '10px'
  },
  link: {
    color: '#2980b9', textDecoration: 'none'
  },
  formContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '30px',
    marginTop: '50px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    alignSelf: 'center'
  },
};

export default LoginForm;
